import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
/**
 * @module ConditionalRoute
 * @category Components
 * @subcategory Containers
 */
/**
 * @lib_candidate
 * @todo document this
 */
export const ConditionalRoute = ({
	path,
	redirectPath,
	shouldRedirect = false,
	children = null,
	...rest
}) => {
	const location = useLocation();
	const redirect = {
		pathname: redirectPath,
		state: { from: location },
	};

	return (
		<Route path={path} {...rest}>
			{shouldRedirect ? <Redirect to={redirect} /> : children}
		</Route>
	);
};

export default ConditionalRoute;
